import { Suspense } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import { useAuth, useUser } from '@/auth/useAuth'
import { roleLabel } from '@/i18n/labels'
import { env } from '@/config/env'
import { LoadingState, cn } from '@/ui'
import { navItemsFor } from './nav'

function Header() {
  const user = useUser()
  const { logout } = useAuth()
  return (
    <header className="sticky top-0 z-30 flex items-center justify-between gap-2 bg-tg-header-bg px-4 py-3 shadow-sm">
      <div className="min-w-0">
        <div className="truncate text-base font-semibold text-tg-text">{env.appName}</div>
        <div className="truncate text-xs text-tg-hint">
          {user.full_name} · {roleLabel[user.role]}
        </div>
      </div>
      <button
        onClick={() => void logout()}
        className="rounded-lg px-2 py-1 text-sm text-tg-link active:bg-black/5"
      >
        Выйти
      </button>
    </header>
  )
}

function BottomNav() {
  const user = useUser()
  const items = navItemsFor(user.role)
  return (
    <nav className="sticky bottom-0 z-30 grid grid-flow-col border-t border-black/5 bg-tg-header-bg pb-[env(safe-area-inset-bottom)]">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            cn(
              'flex flex-col items-center gap-1 py-2 text-xs',
              isActive ? 'text-tg-link' : 'text-tg-hint',
            )
          }
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
            <path
              d={item.icon}
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {item.label}
        </NavLink>
      ))}
    </nav>
  )
}

export function AppLayout() {
  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col bg-tg-bg">
      <Header />
      <main className="flex-1 px-3 py-3">
        <Suspense fallback={<LoadingState />}>
          <Outlet />
        </Suspense>
      </main>
      <BottomNav />
    </div>
  )
}
